/**
 * View Layout Components
 * 
 * A collection of reusable React components for building custom MDX views.
 * These components are designed to work seamlessly with Material UI and
 * provide a consistent, professional appearance for curated content experiences.
 */

// Layout components
export { FunnelLayout } from './FunnelLayout';
export { Section } from './Section';
export { Grid, GridItem, MasonryGrid } from './Grid';
export { 
  Callout, 
  InfoCallout, 
  WarningCallout, 
  ErrorCallout, 
  SuccessCallout, 
  TipCallout, 
  ImportantCallout 
} from './Callout';
export { Hero } from './Hero';
export { KPI } from './KPI';

// Default export for convenience
export default {
  FunnelLayout: require('./FunnelLayout').FunnelLayout,
  Section: require('./Section').Section,
  Grid: require('./Grid').Grid,
  GridItem: require('./Grid').GridItem,
  MasonryGrid: require('./Grid').MasonryGrid,
  Callout: require('./Callout').Callout,
  Hero: require('./Hero').Hero,
  KPI: require('./KPI').KPI,
};